// ---------------------------------------
// TnLive.js
// Video Library with always running video stream
// ---------------------------------------

import { play, pause, register } from '../services/players';

const TnLiveHP = {
  videoId: null,
  videoFrame: null,
  playable: true,
  limiterIsActive: false,

  Init: function () {
    if ($('.-tnlive-headline').length === 0) {
      return;
    }
    TnLiveHP.HeadlineDomManipulate();
    TnLiveHP.TnLiveHpEvents.ScrollEvent();
  },

  HeadlineDomManipulate: function () {
    const wrapperArticle = $('.-tnlive-headline');
    wrapperArticle.addClass('skip-tracking-player');
    const wrappingSection = wrapperArticle.closest('.c-section');
    TnLiveHP.videoFrame = $('.-tnlive-headline iframe[data-video-id]');
    TnLiveHP.videoId = $(TnLiveHP.videoFrame).attr('data-video-id');
    wrappingSection.addClass('-hero-v3-dark');

    if (wrapperArticle.attr('data-live-limiter')){
      this.limiterIsActive = true;
    }

    $.each(wrappingSection.find('.container').find('>div'), function () {
      $(this).wrap("<div class='container'></div>");
    });
    wrapperArticle
      .closest('.container')
      .wrap("<div class='-tnlive-headline-wrapper'></div>");
    $(TnLiveHP.videoFrame).removeClass('kframe');

    let ticks = 0;

    if (this.limiterIsActive) {
      register((data = {}) => {
        const playerId = data?.customData?.videoID;
  
        // eslint-disable-next-line default-case
        switch (data.eventName) {
          case 'timeupdate':
            if (playerId == this.videoId) {
              ticks++;
  
              if (ticks == 15) {
                pause(playerId);
                wrapperArticle.addClass('livestream-stopped');
                TnLiveHP.playable = false;
              }
            }
            break;
        }
      });
    }
  },

  TnLiveHpEvents: {
    ScrollEvent: function () {
      let isThrottled = false;

      $(window).on('scroll', function () {
        if (!isThrottled && TnLiveHP.playable && TnLiveHP.limiterIsActive) {
          isThrottled = true;
          setTimeout(function () {
            TnLiveHP.TnLiveHpEvents.PlayPauseCheck();
            isThrottled = false;
          }, 100); // Throttle scroll actions with a 100ms interval
        }
      });
    },

    PlayPauseCheck: function () {
      const bounding = $(TnLiveHP.videoFrame)[0].getBoundingClientRect();
      const inViewport =
        bounding.top < window.innerHeight && bounding.bottom > 0;
      inViewport ? play(TnLiveHP.videoId) : pause(TnLiveHP.videoId);
    },
  },
};

window.TnLiveHP = TnLiveHP;
export default TnLiveHP;
